import { render, staticRenderFns } from "./TextEditorVideoDialog.vue?vue&type=template&id=2c516248"
import script from "./TextEditorVideoDialog.vue?vue&type=script&lang=ts"
export * from "./TextEditorVideoDialog.vue?vue&type=script&lang=ts"
import style0 from "./TextEditorVideoDialog.vue?vue&type=style&index=0&id=2c516248&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports